const name = "headerIntegration";
export default name;
